!function($) {
  "use strict";

  $(document).ready(function() {
    $("#related_maps_data_carousel").carousel({
      interval: false
    });
  });
}(window.jQuery);
